module.exports = __webpack_public_path__ + "static/media/stripe-create-account_2.2506f152.png";